import { useTranslation } from 'react-i18next';
import { getFormErrorMessage } from '../../utils/formErrors';
import { getTranslation } from '../../utils/translation';

export default function CheckBoxInput({
  label,
  name,
  className,
  error,
  touched,
  color,
  fieldType,
  onChange,
  fieldValue,
  labelClassName = 'text-cblack-primary',
  inputClassName = '',
  errorBaseKey = 'error',
  errorTranslationKey,
  ...props
}) {
  const { t } = useTranslation();
  const getErrorMessage = () => {
    return getFormErrorMessage({
      t,
      getTranslation,
      errorBaseKey,
      error,
      errorTranslationKey
    });
  };
  const errorMessage = error && touched ? getErrorMessage() : '';

  return (
    <div className={`${className} flex flex-col`}>
      <label htmlFor={name} className={`block ${labelClassName}`}>
        <input
          className={`px-3 py-5 rounded w-full ${color} rounded-md text-20 font-normal landing-[138%] text-gray-primary mb-7 ${inputClassName}`}
          id={name}
          name={name}
          value={fieldValue}
          onChange={onChange}
          type={fieldType}
          {...props}
        />
        {label && (
          <span
            className={`block pl-10 sm:pl-7 landing-[138%] ${labelClassName}`}
            dangerouslySetInnerHTML={{
              __html: label
            }}
          />
        )}
      </label>
      {errorMessage && <p className="text text-sm !text-[#ef5252] ml-7">{errorMessage}</p>}
    </div>
  );
}

CheckBoxInput.defaultProps = {
  className: ''
};
